import Vue from 'vue'
import Constants from 'src/utilities/constants'
import {userDisplayNameLabel} from 'src/utilities/utils'
import {ptracGet, ptracGetEntities} from 'src/utilities/ptracApi'
import {NO_CONTENT, OK} from 'http-status-codes'
import _ from 'lodash'
import {make} from 'vuex-pathify'

const initialState = {
  results: [],
  autocompleteResults: [],
  fileInUse: false,
  fileName: null,
  fileSystem: {files: [], folders: []}
}

const state = Vue.util.extend({}, initialState)

const getters = make.getters(state)
const mutations = make.mutations(state)
mutations.resetResults = (state) => {
  state.results = []
}
mutations.reset = (state) => {
  for (let f in state) {
    Vue.set(state, f, initialState[f])
  }
}
mutations.deleteForm = (state, id) => {
  state.results = _.filter(state.results, (file) => file.id !== id)
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchResults({state, commit, dispatch, rootGetters}, query) {
      const payload = {
        query,
        path: Constants.FOLDERS.INSPECTION_FORMS
      }

      const response = await dispatch('files/fetchResults', payload, {root: true})

      if (OK === response.status) {
        userDisplayNameLabel(response.data, rootGetters['users/displayName'], 'uploadedBy')
        commit('results', response.data)
      }

      return response
    },
    async fetchResultsByTaskNameId({state, dispatch, rootGetters}, taskNameId) {
      const response = await dispatch('fetchById', {
        endpoint: 'task-names',
        id: taskNameId
      }, {root: true})

      if (OK === response.status) {
        const taskName = response.data
        const fileIds = _.map(taskName.files, 'fileId')

        if (fileIds && fileIds.length > 0) {
          const url = `files/search/findByIdIn?ids=${fileIds.join()}&sort=name,asc`

          const filesResponse = await ptracGetEntities(url, 'ptracFiles')

          if (OK === filesResponse.status) {
            userDisplayNameLabel(filesResponse.data, rootGetters['users/displayName'], 'uploadedBy')
            state.results = filesResponse.data
          }

          return filesResponse
        }
      }

      return response
    },
    async fetchUnassociated({rootGetters, state}) {
      const response = await ptracGet('files/fetchUnassociatedInspectionForms')

      if (OK === response.status) {
        userDisplayNameLabel(response.data, rootGetters['users/displayName'], 'uploadedBy')
        state.results = response.data
      }
      return response
    },
    async fetchAll({dispatch, state, rootGetters}) {
      const payload = {
        path: Constants.FOLDERS.INSPECTION_FORMS
      }
      const response = await dispatch('files/fetchAllByPath', payload, {root: true})
      if (OK === response.status) {
        userDisplayNameLabel(response.data, rootGetters['users/displayName'], 'uploadedBy')
        state.results = response.data
      }

      return response
    },
    async fileNameStartsWith({ state }, name) {
      const response = await ptracGetEntities('files/search/findByNameStartsWithIgnoreCaseAndPathOrderByNameAsc?path=' +
        encodeURI(Constants.FOLDERS.INSPECTION_FORMS) + '&name=' + name, 'ptracFiles')

      if (OK === response.status) {
        state.autocompleteResults = response.data
      }
    },
    async deleteOne({commit, dispatch}, file) {
      const response = await dispatch('files/deleteOne', file, {root: true})

      if (NO_CONTENT === response.status) {
        commit('deleteForm', file.id)
      }

      return response
    }
  }
}
